import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Box } from 'rebass';
import { useHistory } from 'react-router-dom';
import useMode from '../../hooks/useMode';
import { useStoreFilters } from '../../hooks/useStoredFilters';

const APPROVAL_QUERY = gql`
  query PendingTestApprovals {
    testReportsApproval: backflowTests(
      where: { waterSupplierStatus: "NEEDS_APPROVAL" }
      aggregate: [{ col: "jobId", type: DISTINCT, as: "backflowTests" }]
      limit: null
    ) {
      agg
    }
  }
`;

type ApprovalData = {
  testReportsApproval: {
    agg: {
      backflowTests: number;
    };
  }[];
};

type TestReportApprovalsWidgetProps = {
  width: number;
  height: number;
};

const TestReportApprovalsWidget = ({
  width,
  height,
}: TestReportApprovalsWidgetProps): JSX.Element => {
  const { data } = useQuery<ApprovalData>(APPROVAL_QUERY, {
    fetchPolicy: 'no-cache',
  });

  const history = useHistory();
  const mode = useMode();

  const storeFilters = useStoreFilters('testReports');

  return (
    <>
      {data && (
        <Box
          sx={{
            flexGrow: 1,
            textAlign: 'center',
            fontSize: height * 0.7,
            lineHeight: 1.4,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
            },
          }}
          onClick={() => {
            storeFilters({
              waterSupplierStatus: ['NEEDS_APPROVAL'],
            });
            history.push(`/${mode}/test-reports`);
          }}
        >
          {data.testReportsApproval[0]?.agg.backflowTests}
        </Box>
      )}
    </>
  );
};

export default TestReportApprovalsWidget;
